import { apiInstance } from "@/api/instance";

export default async function (counselId, commentId, data) {
  return apiInstance.delete(`/counsel/${counselId}/comment/${commentId}`, { data });
}
